import React from "react";
import { useQuery } from "react-query";
import { getCountries } from "./gateway";

function useGetCountries({ enabled }: { enabled: boolean }) {
  return useQuery({
    queryFn: getCountries,
    queryKey: "countries-user-registration",
    enabled,
  });
}

export default useGetCountries;
